/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';
import _ from 'lodash';
import FeedTransport from 'scripts/transports/feed-transport';
import { getValidCards } from 'scripts/models/api/cards/cards';

const latestFeedUrls = _.get(window, 'globalSettings.feeds.timeline', {});
const playerFeedUrl = window.globalSettings.feeds.timeline['playerFeedUrl'];
const videoFeedUrl = window.globalSettings.feeds.videoPages;

export default Construct.extend({}, can.event).extend({

    loadLatest(type = 'all', identifier, page = 1, timelineType = 'latest') {
        const baseUrl = latestFeedUrls[`${timelineType}FeedUrl`];

        if (!baseUrl) {
            return;
        }

        const url = can.sub(baseUrl, {filter: type, index: page, identifier});
        return this.fetch(url, timelineType);
    },

    loadPlayer(type = 'all', identifier, page) {
        const url = can.sub(playerFeedUrl, {filter: type, identifier, index: page});
        return this.fetch(url);
    },

    loadVideoDetail(tagname, offset = 0, limit = 4) {
        const url = can.sub(videoFeedUrl, {tagname, offset, limit});
        return FeedTransport.request(url, true)
            .then(data => {
                return [data.cards, data.count, data.offset, data.limit];
            })
            .fail(error => {
                return can.Deferred().reject(error);
            });
    },

    fetch: function (url, timelineType = 'latest') {
        this.dispatch('loading', [true]);
        return FeedTransport.request(url, true)
            .then(data => {
                this.dispatch('data', [getValidCards(data.cards, timelineType), data.total, data.index]);
                this.dispatch('loading', [false]);
                return data;
            })
            .fail(error => {
                this.dispatch('error', [error])
            });
    },

    request(url) {
        return FeedTransport.request(url, true)
            .then(data => {
                return [data.cards, data.total, data.index];
            })
            .fail(error => {
                return can.Deferred().reject(error);
            })
        ;
    }
});
